import { UserOutlined } from "@ant-design/icons";
import { Checkbox, DatePicker, Form, Input, Modal, Switch } from "antd";
import React from "react";
import { api } from "services/api";
import Swal from "sweetalert2";
import { IAddUsers } from "types";
import { getBase64Img } from "utils";

export const AddUserModal: React.FC<IAddUsers> = ({ ...props }) => {
	const {
		form,
		isOpen,
		setCurrentImgURL,
		setIsOpen,
		// userStatus,
		userRoles,
		currentImgURL,
		setUserStatus,
		userStatus,
		setUserRoles,
		setBirthDate,
		birthdate,
		setUsers,
	} = props;

	const handleRegister = (values: any) => {
		api
			.post("/manager/users", values)
			.then((result) => {
				if ([200, 201].includes(result.status)) {
					const {
						data: { feedback },
					} = result;
					setUsers && setUsers(undefined);
					api.get("/manager/users").then((res) => {
						setUsers && setUsers(res.data.data.users);
					});
					form.resetFields();
					Swal.fire({
						icon: "success",
						text: feedback["success"],
						confirmButtonColor: "#63b8cd",
					}).then(() => {
						setIsOpen(false);
						setCurrentImgURL("");
						setUserRoles([]);
						form.resetFields();
						setUserStatus(false);
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
			})
			.catch((err) => {
				const status = err.response.status;
				const { feedback, errors } = err.response?.data;
				if (
					status === 400 ||
					status === 401 ||
					status === 404 ||
					status === 403 ||
					status === 500
				) {
					Swal.fire({
						icon: "error",
						text: feedback["error"]
							? feedback["error"]
							: "Desculpe, ocorreu algum problema =( Por favor tente novamente",
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
				if (status === 422) {
					Swal.fire({
						icon: "error",
						text: errors?.message
							? errors?.message
							: "Desculpe, ocorreu algum problema =( Por favor tente novamente",
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
			});
	};

	return (
		<Modal
			title={<p style={{ margin: 0 }}>Cadastrar novo usuário</p>}
			open={isOpen}
			maskClosable={false}
			okText="Cadastrar usuário"
			cancelText="Cancelar"
			onOk={() => {
				form
					.validateFields()
					.then((values) => {
						const allValues = {
							...values,
							birth_date: `${birthdate}`,
							type_auth: "email",
							password_confirmation: form.getFieldValue("password"),
							roles: userRoles,
						};
						handleRegister(allValues);
						console.log(allValues);
					})
					.catch((info) => {
						console.log("Validate Failed:", info);
					});
			}}
			onCancel={() => {
				setIsOpen(!isOpen);
				setCurrentImgURL("");
				setUserRoles([]);
				form.resetFields();
				setUserStatus(false);
			}}
			className="modal-users"
		>
			<Form form={form} name="new-user" autoComplete="off">
				<div className="users-modal">
					<div className="users-modal__status">
						<p>Status do usuário</p>
						<Switch checked={userStatus} onClick={(e) => setUserStatus(e)} />
					</div>
					<div
						className="users-modal__login-info"
						style={{ marginTop: "15px" }}
					>
						<div className="users-modal__login-info__avatar">
							{currentImgURL ? (
								<img src={currentImgURL} alt="" width="100%" height="100%" />
							) : (
								<UserOutlined twoToneColor="#000" />
							)}
							{/* <label
								htmlFor="avatar"
								className="users-modal__login-info__avatar__btn"
							>
								Escolha uma foto
							</label> */}
							<Input
								id="avatar"
								type="file"
								accept="image/*"
								style={{ display: "none" }}
								onChange={(e) => {
									getBase64Img(e.target.files?.[0] as Blob, setCurrentImgURL);
								}}
							/>
						</div>
						<div className="users-modal__login-info__inputs">
							<Form.Item
								name="name"
								rules={[
									{
										required: true,
										message: "Nome necessário",
									},
								]}
							>
								<Input placeholder="Nome" />
							</Form.Item>
							<Form.Item
								name="username"
								rules={[
									{
										required: true,
										message: "Username necessário",
									},
								]}
							>
								<Input placeholder="Username" />
							</Form.Item>
							<Form.Item
								name="email"
								rules={[
									{
										required: true,
										message: "E-mail necessário",
									},
								]}
							>
								<Input placeholder="E-mail" />
							</Form.Item>

							<Form.Item
								name="password"
								rules={[{ required: true, message: "Senha necessária" }]}
							>
								<Input.Password placeholder="Senha" />
							</Form.Item>
							<Form.Item
								name={"birth_date"}
								rules={[
									{
										required: true,
										message: "Data de nascimento necessária",
									},
								]}
							>
								<DatePicker
									format={"DD/MM/YYYY"}
									placeholder={"Data de Nascimento"}
									onChange={(_, date) => setBirthDate && setBirthDate(date)}
								/>
							</Form.Item>
						</div>
						<div
							className="users-modal__login-info"
							style={{ marginLeft: "20px", width: "310px" }}
						>
							<div className="users-modal__login-info__user-types">
								<h1>Perfil do usuário</h1>
								<Checkbox.Group
									style={{ width: "100%" }}
									value={userRoles}
									onChange={(e) => setUserRoles(e)}
								>
									<Checkbox value="aluno">Aluno</Checkbox>

									<Checkbox value="professor">Professor</Checkbox>

									<Checkbox value="gestor">Gestor</Checkbox>
								</Checkbox.Group>
							</div>
						</div>
					</div>
				</div>
			</Form>
		</Modal>
	);
};
